var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicsvgDownload20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "346.000000pt",
    viewBox: "0 0 300.000000 346.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,346.000000) scale(0.050000,-0.050000)",
    fill: "#e19b3c",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2720 5310 c-454 -124 -665 -246 -930 -536 -330 -362 -457 -656 -500 -1166 -44 -524 334 -1227 802 -1489 43 -24 103 -62 134 -84 416 -294 1221 -285 1734 21 50 30 113 64 140 76 63 28 323 278 373 358 20 33 66 99 102 147 36 47 71 110 78 140 7 29 38 116 69 194 50 126 75 249 112 557 23 194 -106 742 -201 849 -16 18 -51 78 -79 133 -174 342 -536 616 -1004 760 -99 30 -189 61 -200 70 -48 36 -458 17 -630 -30z m713 -202 c366 -95 810 -390 875 -580 16 -49 60 -127 98 -173 248 -310 292 -1044 86 -1429 -28 -53 -61 -122 -72 -154 -147 -402 -795 -773 -1348 -772 -309 1 -723 125 -846 253 -35 37 -81 67 -102 67 -106 0 -439 451 -551 747 -91 241 -102 695 -22 952 245 796 1104 1292 1882 1089z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2150 4312 c-74 -34 -103 -81 -119 -194 -25 -177 96 -178 181 -1 70 146 138 161 241 52 90 -96 86 -116 -55 -279 -116 -135 -120 -144 -119 -250 1 -60 -4 -147 -11 -193 -10 -73 -7 -85 32 -97 68 -21 124 41 108 122 -11 59 1 117 58 274 11 31 55 89 98 130 134 125 147 168 86 280 -93 172 -312 240 -500 156z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3497 4315 c-134 -108 -185 -317 -81 -332 64 -9 104 31 104 104 1 87 17 105 115 132 220 59 272 -154 84 -346 -55 -55 -100 -119 -102 -142 -6 -77 4 -119 37 -155 27 -30 27 -36 3 -36 -84 0 -142 -140 -74 -182 130 -83 263 59 152 163 -41 38 -42 44 -12 66 18 14 43 62 55 107 21 78 69 133 178 206 100 66 82 243 -35 362 -84 85 -345 117 -424 53z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicsvgDownload20);
export default __webpack_public_path__ + "static/media/picsvg_download (20).ed6cdcac770f8f22897179d9b5c639d7.svg";
export { ForwardRef as ReactComponent };